import React from "react"
import { createRoot } from 'react-dom/client';
import Bracket from "./react/components/bracket/index";

window.loadReactFront = function loadReactFront(wrapperID, props, module) {
  const container = document.getElementById(wrapperID);
  const frontRoot = createRoot(container);

  switch (module) {
    case 'bracket_builder':
      const propsData = { ...props[0], isFront: true };
      frontRoot.render(<Bracket {...propsData} />)
      break;
    default:
      break;
  }
}
